import guid from '@/lib/guid';
import {createDataSource, createDataSourceFromString, transformPaste, transformSQL} from '@/models/data-source';
import Vue from 'vue';
import {getFromStorage, saveInStorage} from '@/services/localstorage.service';

const inputTransformations = {
  'paste': transformPaste,
  'sql': transformSQL,
  // 'apiList':
}

export default {
  mInit(state, ds) {
    Vue.set(state, 'allDataSources', ds);
    let dataSources = ds.filter(item => !item.parents.length);


    Vue.set(state, 'dataSources', dataSources);
    console.log("dataSources", dataSources);
    if(dataSources.length) {

      const storedKey = getFromStorage(dataSources[0].getStorageKey());
      //console.log("storedKey", storedKey);
      let dataSource = dataSources.find(d => d.id == storedKey);
      if(!dataSource) {
        dataSource = dataSources[0];
      }
      dataSource.dataSources = state.dataSources;
      state.dataSource = dataSource;



      if(state.aceEditor && dataSource.baseQuery) {
        console.log("aceEditor", dataSource);
        state.aceEditor.setValue(dataSource.baseQuery)
      }
      state.dataSource.pageSize = state.pageSize;
      state.dataSource.update();

    } else {
      state.dataSource = {};
    }
  },
  mAdd (state, dataSource = null) {
    if(!dataSource) {
      const append = state.dataSources.length + 1;
      let dataSource = createDataSource({name: 'Sheet ' + append, projectId: state.projectId});
    }

    dataSource.dataSources = state.dataSources;
    Vue.set(state, "dataSource", dataSource);



    if(state.aceEditor && dataSource.baseQuery) {
      // state.aceEditor.setValue(dataSource.baseQuery)
    }

    Vue.set(state, "dataSource", dataSource);

    if(typeof state.dataSource.baseQuery != "undefined" && state.dataSource.baseQuery) {
      console.log("setting ace 1", state.dataSource);
      state.aceEditor.setValue(state.dataSource.baseQuery);
    } else {
      state.aceEditor.setValue("");
      console.log("not setting ace 1", state.dataSource);
    }

    state.dataSource.pageSize = state.pageSize;
    state.dataSource.update();

    state.dataSources.push(dataSource);
  },
  mSetDataSource (state, dataSource) {
    dataSource.dataSources = state.dataSources;
    dataSource.saveInStorage();
    const storedKey = getFromStorage(dataSource.getStorageKey());
    // console.log("storedKey", storedKey);
    state.dataSource = dataSource;

    if(typeof state.dataSource.baseQuery != "undefined" && state.dataSource.baseQuery) {
      console.log("setting ace 2", state.dataSource);
      state.aceEditor.setValue(state.dataSource.baseQuery);
    } else {
      state.aceEditor.setValue("");
      console.log("not setting ace 2", state.dataSource);
    }



    state.dataSource.pageSize = state.pageSize;
    state.dataSource.update();
  },
  mSetProjectId (state, projectId) {
    Vue.set(state, "projectId", projectId);
  },
  mSetTables (state, tables) {
    Vue.set(state, "tables", tables);
  },
  mUpdatePaste(state, paste) {

  },
  mSetName (state, name) {
    state.dataSource.name = name;
  },
  mSetType (state, type) {
    state.dataSource.type = type;
  },

  mSetAceEditor (state, aceEditor) {

    //if(typeof state.aceEditor == "undefined" || !state.aceEditor) {
    state.aceEditor = aceEditor;
    //}
    if(typeof state.dataSource.baseQuery != "undefined" && state.dataSource.baseQuery) {
      console.log("setting ace 2", state.dataSource);
      state.aceEditor.setValue(state.dataSource.baseQuery);
    } else {
        state.aceEditor.setValue("");
      console.log("not setting ace 2", state.dataSource);
    }
  //  console.log(state.aceEditor);
  },
  mDelete (state, dataSource) {
    state.dataSources.splice(state.dataSources.indexOf(dataSource), 1);
  //  state.dataSource = state.dataSources[0];

//    if(state.aceEditor) {
  //    state.aceEditor.setValue(state.dataSources[0].input)
  //  }
  },
  mSetInput(state, dataSource) {
    if(state.aceEditor) {
      // dataSource.input = state.aceEditor.getValue();
      // console.log("mSetInput", "mSetInput");
      Vue.set(state.dataSource, 'baseQuery', state.aceEditor.getValue());
    }
  },
  mSetRelatedSources (state, dataSources) {
    let relatedSources = {};
    let id = state.dataSources.length + 1;
    for(let i = 0; i < dataSources.length; i++) {
      const dataSource = dataSources[i];
      if(!dataSource.columnId) {
        continue;
      }

      if(typeof relatedSources[dataSource.columnId] == "undefined") {
        let relatedSource = dataSources.find(item => item.columnId == dataSource.columnId && item.type == 'union_view');
        id++;
        if(!relatedSource) {
          const c = dataSources.filter(d => d.type == 'union_view').length + 1;
          let name = "Merged Worksheet " + c;
          relatedSource = {id: null, dataSource: createDataSource({name: name, projectId: state.projectId}), name: name, size: 0, dataSources: [], childrenIds:[]};

        }
        relatedSources[dataSource.columnId] = relatedSource;
    }
      if(dataSource.type.startsWith("union_")) {
        relatedSources[dataSource.columnId].id = dataSource.id;
        relatedSources[dataSource.columnId].name = dataSource.name;
        relatedSources[dataSource.columnId].dataSource = dataSource;
      } else if(dataSource.type.startsWith("jdbc")) {
        relatedSources[dataSource.columnId].dataSources.push(dataSource);
        relatedSources[dataSource.columnId].childrenIds.push(dataSource.id);
        relatedSources[dataSource.columnId].size++;
      }
    }

    relatedSources = Object.values(relatedSources).filter(source => source.size > 1);
    console.log("relatedSources", relatedSources);
    Vue.set(state, "relatedSourcesFound", relatedSources.length);
    Vue.set(state, "relatedSources", relatedSources);
  },
  mSetVariable(state, variable, value) {
    Vue.set(state, variable, value);
  },
  mLoading(state, b) {
    Vue.set(state.dataSource, "loading", b);
  },
  mUpdate(state, dataSource) {
    // Vue.set(state, "dataSource", dataSource);
  },
  mSave (state, dataSource) {
    if(state.aceEditor) {
      Vue.set(state.dataSource, 'baseQuery', state.aceEditor.getValue());
    }
    Vue.set(state.dataSource, "loading", true);

    // console.log("udated here");
    dataSource.update();

/**
    if(inputTransformations.hasOwnProperty(dataSource.type)) {
      // console.log("type : " + dataSource.type);
      inputTransformations[dataSource.type](dataSource, state.dataSources).then(function(result) {
        // console.log(result.data.length);
        // console.log(JSON.stringify(result));
        Object.freeze(result.data);

        const size = result.data.length;
        const filteredData = result.data.slice(0, state.dataSource.pageSize);


        Vue.set(state.dataSource, 'data', result.data);
        Vue.set(state.dataSource, 'size', size);
        Vue.set(state.dataSource, 'filteredData', filteredData);
        Vue.set(state.dataSource, 'headers', result.headers);
        Vue.set(state.dataSource, "loading", false);
      }).catch(function(err) {
        console.log(err);
        Vue.set(state.dataSource, 'data', []);
        Vue.set(state.dataSource, 'filteredData', []);
        Vue.set(state.dataSource, 'headers', []);
        Vue.set(state.dataSource, "loading", false);
      });
    }**/


  }
};
